module.exports = "<svg class=\"sparkline\" width=\"100\" height=\"30\" stroke-width=\"2\" #svg></svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/sparkline/sparkline.component.html
// module id = ../../../../../src/app/shared/sparkline/sparkline.component.html
// module chunks = 2